/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 7ed6ffcc05fc
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { ResourceType, ResourceType$zodSchema } from "./resourcetype.js";
import {
  TagsListResponse,
  TagsListResponse$zodSchema,
} from "./tagslistresponse.js";

export type ListResourceTagsGlobals = { cloud_name?: string | undefined };

export const ListResourceTagsGlobals$zodSchema: z.ZodType<
  ListResourceTagsGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type ListResourceTagsRequest = {
  resource_type: ResourceType;
  prefix?: string | undefined;
  next_cursor?: string | undefined;
  max_results?: number | undefined;
};

export const ListResourceTagsRequest$zodSchema: z.ZodType<
  ListResourceTagsRequest
> = z.object({
  max_results: z.int().describe("Maximum number of results to return (1-500).")
    .optional(),
  next_cursor: z.string().describe("Cursor for pagination.").optional(),
  prefix: z.string().describe(
    "Limit the returned tags to those that start with the specified prefix.",
  ).optional(),
  resource_type: ResourceType$zodSchema.describe(
    "The type of resource (image, video, or raw).",
  ),
});

export type ListResourceTagsResponse = ApiError | TagsListResponse;

export const ListResourceTagsResponse$zodSchema: z.ZodType<
  ListResourceTagsResponse
> = z.union([
  ApiError$zodSchema,
  TagsListResponse$zodSchema,
]);
